import RouteModel from "../../model-factory/basic/route/RouteModel";
import {FactoryID, RouteKey} from "../../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";
import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import {getManager} from "../../manager/Manager";
import {getModelFactory} from "../../model-factory/ModelFactory";
import {cardOutline} from "ionicons/icons";
import {IStringObject} from "../../common/SimpleInterface";

export class MyProfileRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "my_profile_route_id";
    choiceOrder: string[] = [];

    createChoiceOrder(): string[]|null
    {

        if(!getManager().user.loggedIn()){
            return ["account"];
        } else if(!getManager().user.organisationID){

            return ["add", "account"];
        } else {
            return ["project", "offer", "account", "activity"];
        }
    }

    applyChoice(choice: RouteChoice)
    {
        if(choice.id === "add"){
            choice.pageID = getManager().post.config.organisation.addPageID;
        }
        super.applyChoice(choice);
    }
}

export default class MyProfileRouteFactory extends RouteFactory
{

    id: FactoryID = "my_profile_route";

    constructor()
    {
        super();

        this.choices = {
            add: new RouteChoice({
                name: "Register an Organisation",
                derivedRouteIDs: {
                    post_type: "organisation"
                }
            }),
            activity: new RouteChoice({
                name: "Activity"
            }),
            edit: new RouteChoice({
                name: "Edit My Organisation",
                derivedRouteIDs: {
                    post_type: "organisation"
                }
            }),
            project: new RouteChoice({
                name: "Projects",
                publicID: "projects",
                nextFactoryID: "post_route",
                isSecondaryRoute: true,
                derivedRouteIDs: {
                    post_type: "project"
                }
            }),
            offer: new RouteChoice({
                name: "Offers",
                publicID: "offers",
                nextFactoryID: "post_route",
                isSecondaryRoute: true,
                derivedRouteIDs: {
                    post_type: "offer"
                }
            }),
            account: new RouteChoice({
                name: "Account",
                nextFactoryID: "account_route",
                requiresLogin: true,
                isSecondaryRoute: true,
                conditionalClassName: () => {
                    return getManager().user.unreadMessageCount ? "unread-message" : "";
                }
            })
        }
    }

    birth(id: FactoryID): MyProfileRouteModel
    {
        return new MyProfileRouteModel(id);
    }

    getDefaultModel(): MyProfileRouteModel
    {
        return this.getDefaultModelWithRoute()! as MyProfileRouteModel;
    }

    getValidParamKeys(routeIDs:IRouteIDs, params:IStringObject):string[]
    {
        return ["activity_type", "activity_post_type", "activity_post_id"];
    }

    getAdditionalRouteIDs(routeIDs: IRouteIDs, params: IStringObject, hash: string, suppliedRouteIDs?: IRouteIDs|null): IRouteIDs
    {
        const additionalIDs = super.getAdditionalRouteIDs(routeIDs, params, hash, suppliedRouteIDs);

        if(suppliedRouteIDs?.activity_type_id){
            additionalIDs.activity_type_id = suppliedRouteIDs.activity_type_id;
        } else if(params["activity_type"]){
            additionalIDs.search_term_id = params.activity_type;
        }

        if(suppliedRouteIDs?.activity_post_type_id){
            additionalIDs.activity_post_type_id = suppliedRouteIDs.activity_post_type_id;
        } else if(params["activity_post_type"]){
            additionalIDs.activity_post_type_id = params.activity_post_type;
        }

        if(suppliedRouteIDs?.activity_post_id){
            additionalIDs.activity_post_id = suppliedRouteIDs.activity_post_id;
        } else if(params["activity_type"]){
            additionalIDs.activity_post_id = params.activity_post_id;
        }

        return additionalIDs;
    }

    defaultRouteIDs(): IRouteIDs
    {
        return {
            browse_route_id: "my_profile"
        };
    }
}